import { FC } from 'react'
import { Box, Stack, SvgIconProps, useTheme } from '@mui/material'
import LoadedLink from '../../display/LoadedLink'

export type SideNavItem = {
  label: string
  Icon: React.ComponentType<SvgIconProps>
  path: string
  active?: boolean
}

type SideNavMenuItemProps = {
  item: SideNavItem
}

/**
 * Individual menu item within the side navigation.
 * Displays text with proper styling and spacing.
 */
const SideNavMenuItem: FC<SideNavMenuItemProps> = ({ item }) => {
  const theme = useTheme()

  return (
    <Box
      component="li"
      sx={{
        height: '55px',
        display: 'flex',
        alignItems: 'center',
        fontSize: '14px',
        textTransform: 'uppercase',
        color: theme.app.sidenavTextColor,
        paddingLeft: '26px',
        ...(item.active && {
          background: 'rgba(0, 0, 0, 0.05)',
        }),
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <item.Icon
          sx={{
            width: '0.8em',
            height: '0.8em',
          }}
        />
        <LoadedLink
          to={item.path}
          component="a"
          href={'/App/#' + item.path}
          sx={{
            fontSize: '14px',
            textTransform: 'uppercase',
            color: theme.app.sidenavTextColor,
            fontWeight: '600',
            marginLeft: '8px !important',
          }}
        >
          {item.label}
        </LoadedLink>
      </Stack>
    </Box>
  )
}

export default SideNavMenuItem
